<template>
  <div class="school_index_page">
    <div class="school_box">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params: {},
      layerpageinfo: {
        pageSize: 16,
        pageNo: 0,
        total: 0
      },
      searchObj: {
        name: ""
      }
    };
  },
  created() {},
  methods: {
    search() {},
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontAssigns();
    }
  }
};
</script>

<style lang="scss">
.school_index_page {
  .page_box {
    margin-bottom: 50px;
  }
   .breadbox{
      padding:20px 0;
    }
  //学校信息
  .school_info {
   
    .box {
      height: 210px;
      padding: 50px 30px 0;
      display: flex;
      background: #fff;
      box-sizing: border-box;
      .left_img {
        img {
          width: 100px;
          height: 100px;
          object-fit: contain;
        }
      }
      .right_txt {
        margin-left: 20px;
        flex: 1;
        .top_name {
          display: flex;
          justify-content: space-between;
        }
        .top_name a {
          font-size: 14px;
          color: $color-default;
        }
        h3 {
          font-size: 20px;
          color: $color-gary3;
          font-weight: bold;
          margin-bottom: 18px;
          display: flex;
          span {
            display: inline-block;
            font-size: 12px;
            font-weight: 400;
            background-color: $color-default;
            color: #fff;
            height: 20px;
            line-height: 20px;
            padding: 0 10px;
            border-radius: 10px;
            margin-left: 10px;
          }
        }
        h4 {
          font-size: 14px;
          line-height: 22px;
          color: $color-gary2;
          opacity: 0.6;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .filtrate {
    height: 80px;
    .el-input__inner{
      border-radius: 20px;
    }
    .filtrate_box {
      display: flex;
      justify-content: space-between;
      ul {
        display: flex;
      }
      ul li {
        font-size: 16px;
        line-height: 80px;
        position: relative;
        margin-right: 60px;
        cursor: pointer;
        a {
          color: $color-gary;
        }
        span {
          color: #ff733c;
        }
      }
      ul li.active {
        a {
          color: $color-default;
          padding: 12px 28px;
          border: 1px solid $color-default;
          border-radius: 20px;
        }
      }
      .filtrate_box_r {
        display: flex;
        align-items: center;
       
      }
    }
  }
}
</style>
